<template>
  <div> 
      <!-- <a-cascader
    :options="TenantList"
     :load-data="loadData"
    placeholder="请选择服务商仓库"
    :allow-clear="false"
    change-on-select
    @change="onChange"
    @popupVisibleChange="handleVisibleChange"
  /> -->
  <el-cascader ref="Cascader" v-model="defaultValue" popper-class="cascaderSelect" :options="TenantList" :props="props" @change="onChange"></el-cascader>
  </div>
</template>

<script>
import {getSignType} from '@/api/enterprise/authentication'
import {getWareHouse} from '@/pages/data/goodsTracking/api'
import { mapMutations } from 'vuex'

  export default {
    props:{
      isDefaultSelect:{
        type:Boolean,
        default:true
      }
    },
    data(){
      return{
        TenantList:[],
        warehoseList:[],
        defaultValue:[],
        selectWareHouse:{},
        props: {
          lazy: true,
          lazyLoad:async (node, resolve)=>{
             // eslint-disable-next-line no-param-reassign
            node.children=[]
            if(node.data){
              this.saveCarrier(node.data)
            }
            if(!node.value){
               resolve([])
              return
            }
            const data={
          customerCodes:[node.value],
          needExcludeDefaultTenant: true,
          tenantName: "",
          isReadConfig:true
          }
          try {
            const res= await getWareHouse(data,{size:500})
            let wareHouseList=[
              {
                 leaf:true,
                 disabled:true
              }
            ]
           if(res.records&&res.records.length){
               wareHouseList=res.records.map(item=>({
              ...item,
              value:item.tenantId,
              label:item.tenantName,
              leaf:true
            }))
           }
            resolve(wareHouseList);
          } catch (error) {
           resolve([])
          }
          }
        }
      }
    },
   async created(){
     await this.getCarrierList()
    },
    methods:{
       ...mapMutations('user', ['SET_USER_DATA']),
      async getCarrierList(){
        const {customers} =this.$store.state.user
        const params=customers.map(item=>item.customerId)
        const data={
          ids:params,
        }
        const res= await getSignType(data)
        this.TenantList=res.map(item=>{
          return {
            ...item,
            value:item.customerCode,
            label:item.customerName,
            children:[]
          }
        })
         this.saveCarrier(res[0])
         this.fetchData(res[0].customerCode)
      },
      async fetchData(customerCode){
        const data={
          customerCodes:[customerCode],
          needExcludeDefaultTenant: true,
          isReadConfig:false
        }
        const res= await getWareHouse(data,{size:500})
        const WareHouse=res.records.map(item=>({
          ...item,
          value:item.tenantId,
          label:item.tenantName,
          leaf:true
        }))
       this.TenantList= this.TenantList.map(item=>{
          if(item.value===customerCode){
            return {
              ...item,
              children:WareHouse
            }
          }
          return {...item}
        })
        if(this.isDefaultSelect&&this.defaultValue.length===0){
          this.defaultValue.push(customerCode)
          this.defaultValue.push(WareHouse[0]?.value)
          this.selectWareHouse=WareHouse[0]||{}
          this.handleVisibleChange(false)
        }
      },
      saveCarrier(select){
         const {carrierTenantId,carrierTenantName,id,customerCode,customerName}=select
         const {customers}=this.$store.state.user
          const accountData={
          id:customers.filter(item=>item.customerId===id)[0].orgId,
          identityId:customerCode
        }
        localStorage.setItem('accountData',JSON.stringify(accountData))
         const selectCarriering={
            tenantId:carrierTenantId,
            tenantName:carrierTenantName,
            customerId:id,
            customerCode,
            customerName,
         }
         Object.keys(selectCarriering).forEach(item=>{
            this.SET_USER_DATA([item,selectCarriering[item]])
         })
      },
      onChange() {
        this.selectWareHouse=this.$refs.Cascader.getCheckedNodes()[0].data||{}
        if (this.defaultValue.length) {
          const current = this.TenantList.find(item => item.value === this.defaultValue[0])
          this.saveCarrier(current)
        }
        this.handleVisibleChange(false)
      },
      handleVisibleChange(value){
        if(!value){
          this.$emit('change', this.selectWareHouse)
        }
      },
      handleClear(){
        this.defaultValue=[]
      }

    }
  }
</script>

<style lang="less" scoped>
.el-cascader {
  width: 100%;
 /deep/.el-input.is-focus .el-input__inner {
   border-color: #06b880;
 }
 /deep/.el-input__inner {
    height: 32px !important;
   line-height: 32px !important;
 }
}

</style>
